import { Component, OnInit, inject } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Page} from '../../../core/pagination/page';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {TherapeutService} from '../../../therapeut/therapeut.service';
import {Therapeut} from '../../../therapeut/therapeut';
import {Router} from '@angular/router';
import {DialogService} from '../../../core/dialog/dialog.service';
import {filter, mergeMap, tap} from 'rxjs/operators';

@Component({
    templateUrl: './therapeuten.page.html',
    styleUrls: ['./therapeuten.page.scss'],
    standalone: false
})
export class TherapeutenPage implements OnInit {
  private therapeutService = inject(TherapeutService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  initialPageRequest: PageRequest<Therapeut> = PageRequest.firstPageRequest<Therapeut>(SortOrder.ASCENDING, 5);
  therapeutenPage$: Subject<Page<Therapeut>> = new Subject<Page<Therapeut>>();
  private currentPageRequest: PageRequest<Therapeut>;

  ngOnInit(): void {
    this.getTherapeuten$(this.initialPageRequest).subscribe();
  }

  navigateToTherapeut(therapeut: Therapeut): void {
    this.router.navigateByUrl(`/therapeuten/${therapeut.getId()}`);
  }

  deleteTherapeut(therapeut: Therapeut): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${therapeut.getVoornaam()} wil verwijderen?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.therapeutService.deleteTherapeut$(therapeut.getId())),
        mergeMap(() => this.getTherapeuten$(this.currentPageRequest.toFirstPage())),
      )
      .subscribe();
  }

  navigateToAddTherapeut(): void {
    this.router.navigateByUrl('/therapeuten/toevoegen');
  }

  onPageChange(pageRequest: PageRequest<Therapeut>): void {
    this.getTherapeuten$(pageRequest).subscribe();
  }

  private getTherapeuten$(pageRequest: PageRequest<Therapeut>): Observable<Page<Therapeut>> {
    this.currentPageRequest = pageRequest;
    return this.therapeutService
      .getTherapeuten$(pageRequest)
      .pipe(tap(page => this.therapeutenPage$.next(page)));
  }
}
